/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateSeasonResponse
 */
export interface CreateSeasonResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateSeasonResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonResponse
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonResponse
     */
    entityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the CreateSeasonResponse interface.
 */
export function instanceOfCreateSeasonResponse(value: object): value is CreateSeasonResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateSeasonResponseFromJSON(json: any): CreateSeasonResponse {
    return CreateSeasonResponseFromJSONTyped(json, false);
}

export function CreateSeasonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSeasonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}

export function CreateSeasonResponseToJSON(json: any): CreateSeasonResponse {
    return CreateSeasonResponseToJSONTyped(json, false);
}

export function CreateSeasonResponseToJSONTyped(value?: CreateSeasonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'entityId': value['entityId'],
        'displayName': value['displayName'],
    };
}

